import { useParams } from 'react-router-dom';
import { OpportunityDetailView } from '../components/opportunity-detail/OpportunityDetailView';

export function OpportunityDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <OpportunityDetailView id={id} variant="page" />;
}
